import BaseResource from './index'

export default class DraftableRacerResource extends BaseResource {
    static endpoint = '/teams/draftables'

    toString() {
        return this.get('display_name')
    }
}
